// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { isExpertLoggedIn, isExpertProtectedPath, redirectToExpertLogin } from '@/expert/utils/expert'
import '@fontsource/work-sans/400.css'
import '@fontsource/work-sans/600.css'
import '@fontsource/work-sans/700.css'
import '@fontsource/work-sans/800.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/manrope/500.css'
import '@fontsource/manrope/600.css'
import '@fontsource/manrope/700.css'
import '@fontsource/manrope/800.css'
import 'material-symbols/index.css'
import './assets/css/tailwind.generated.css'
//引入jQuery
import $ from 'jquery'
import 'bootstrap3/dist/css/bootstrap.min.css'
(function () {
  if (typeof window !== 'undefined') {
    window.$ = $
    window.jQuery = $
  }
})()
require('bootstrap3/dist/js/bootstrap.min.js')

import 'font-awesome/css/font-awesome.min.css'

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})

function redirectLoggedOutExpertHistoryPage () {
  if (isExpertLoggedIn()) {
    return
  }
  const currentPath = window.location.pathname
  if (!isExpertProtectedPath(currentPath)) {
    return
  }
  redirectToExpertLogin({
    redirect: `${currentPath}${window.location.search}`,
    replace: true
  })
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    redirectLoggedOutExpertHistoryPage()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js